import api from './api';
import { 
  Task, 
  TaskCreate, 
  TaskUpdate, 
  SummarizeRequest, 
  SummarizeResponse,
  SubtaskRequest,
  SubtaskResponse,
  PrioritizeRequest,
  PrioritizeResponse
} from '../types/task';

export const getTasks = async (): Promise<Task[]> => {
  const response = await api.get('/tasks/');
  return response.data;
};

export const getTask = async (id: number): Promise<Task> => {
  const response = await api.get(`/tasks/${id}`);
  return response.data;
};

export const createTask = async (task: TaskCreate): Promise<Task> => {
  const response = await api.post('/tasks/', task);
  return response.data;
};

export const updateTask = async (id: number, task: TaskUpdate): Promise<Task> => {
  const response = await api.put(`/tasks/${id}`, task);
  return response.data;
};

export const deleteTask = async (id: number): Promise<void> => {
  await api.delete(`/tasks/${id}/`);
};

export const summarizeTask = async (request: SummarizeRequest): Promise<SummarizeResponse> => {
  const response = await api.post('/summarize/', request);
  return response.data;
};

export const suggestSubtasks = async (request: SubtaskRequest): Promise<SubtaskResponse> => {
  const response = await api.post('/subtasks/', request);
  return response.data;
};

export const prioritizeTasks = async (request: PrioritizeRequest): Promise<PrioritizeResponse> => {
  const response = await api.post('/tasks/ai/prioritize/', request);
  return response.data;
};